import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';
import {Verifier} from "./templates/Verifier";
import './index.css';
import Home from "./pages/home";


function App() {
  return (
      <Router>
          <Switch>
              <Route path="/" exact component={Home} />

              <Route exact path="/verifyhash/:id" render={(props) => (
                  <Verifier hash={props.match.params.id}/>
              )} />


          </Switch>
      </Router>
  );
}

export default App;
